'use client'

import { useScrollBlock } from 'lib/useScrollBlock'
import React, { Suspense } from 'react'
import { FadingList } from './FadingList'
import { LanguageSwitcher } from './LanguageSwitcher'
import { LanguageSwitcherSkeleton } from './LanguageSwitcherSkeleton'
import { MenuItems } from './MenuItems'
import { ANIMATION_DURATION, BackgroundWave } from './Wave'

export type MobileNavigationProps = {
  isActive: boolean
}

export default function MobileNavigation(props: MobileNavigationProps) {
  useScrollBlock(props.isActive)
  const [isVisible, setIsVisible] = React.useState(props.isActive)

  React.useEffect(() => {
    if (isVisible && !props.isActive) {
      const timeout = window.setTimeout(() => {
        setIsVisible(false)
      }, ANIMATION_DURATION * 1000)

      return () => {
        window.clearTimeout(timeout)
      }
    }

    if (!isVisible && props.isActive) {
      setIsVisible(true)
    }
  }, [props.isActive, isVisible])

  if (!isVisible) {
    return null
  }

  return (
    <div className="lg:hidden background-highlight text-black">
      <div className="absolute inset-0 z-20">
        <BackgroundWave isActive={props.isActive} />
      </div>
      <div className="fixed inset-0 pt-96 px-24 pb-64 z-20">
        <nav
          className="flex flex-col text-30 font-light"
          aria-label="Mobile Main Navigation"
        >
          <FadingList active={props.isActive}>
            <MenuItems />
            <Suspense fallback={<LanguageSwitcherSkeleton />}>
              <LanguageSwitcher />
            </Suspense>
          </FadingList>
        </nav>
      </div>
    </div>
  )
}
